import Single from './src/main'

Single.install = function (Vue) {
    Vue.component(Single.name, Single)
}

export default Single